<template>
  <div class="compressed-content">
    <h3 class="page-question">Do you know your highest LDL (“Bad”) cholesterol level from previous testing?</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.highestCholesterolLevel">
      <b-form-radio v-model="survey.bloodBiochemistry.cholesterol.highestCholesterolLevel" name="cholesterol"
                    :value=cholesterolLevel.Unknown>
        Don’t know or never tested
      </b-form-radio>
      <b-form-radio v-model="survey.bloodBiochemistry.cholesterol.highestCholesterolLevel" name="cholesterol"
                    :value=cholesterolLevel.Low>
        Less than 160 mg/dL
      </b-form-radio>
      <b-form-radio v-model="survey.bloodBiochemistry.cholesterol.highestCholesterolLevel" name="cholesterol"
                    :value=cholesterolLevel.High>
        Between 160-189 mg/dL
      </b-form-radio>
      <b-form-radio v-model="survey.bloodBiochemistry.cholesterol.highestCholesterolLevel" name="cholesterol"
                    :value=cholesterolLevel.VeryHigh>
        190 mg/dL or higher
      </b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import cholesterolLevel from "enums/cholesterol-level";
  import { required } from "vuelidate/lib/validators";

  export default {
    mixins: [formMixin],

    data() {
      return {
        cholesterolLevel: cholesterolLevel,
      };
    },

    validations: {
      highestCholesterolLevel: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      highestCholesterolLevel() { return this.survey.bloodBiochemistry.cholesterol.highestCholesterolLevel }
    }
  };
</script>